import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const NicePayResultMob = () => {
  return <CommonResult />;
};

export default NicePayResultMob;
